import { useWizard } from "@/stores/wizard";
import { LabeledInput } from "./LabeledInput";
import { Checkbox } from "./Checkbox";

/**
 * Wizard step 2 for Badge collections — supply cap, expiration, and the
 * three behavior toggles (subsidized gas, soulbound, one-per-address).
 */
export function Step2BadgeConfig() {
  const w = useWizard();
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Every badge token shares the same artwork (the one you uploaded above). Distribution is via
        single-use claim links/QRs you'll generate after deploy.
      </p>
      <div className="grid gap-4 md:grid-cols-2">
        <LabeledInput
          label="Max supply (0 = unlimited)"
          value={w.maxSupply}
          onChange={(v) => w.set("maxSupply", Number(v))}
          type="number"
          min={0}
        />
        <LabeledInput
          label="Valid until (optional)"
          value={w.badgeValidUntil}
          onChange={(v) => w.set("badgeValidUntil", v)}
          type="datetime-local"
        />
      </div>
      <div className="space-y-2">
        <Checkbox
          label="Subsidize gas for claimers"
          value={w.badgeSubsidized}
          onChange={(v) => w.set("badgeSubsidized", v)}
          hint="Atelier relays the mint tx from a derived wallet you fund. If off, claimers pay their own gas."
        />
        <Checkbox
          label="Soulbound"
          value={w.badgeSoulbound}
          onChange={(v) => w.set("badgeSoulbound", v)}
          hint="Tokens cannot be transferred after minting (POAP-style attendance proofs)."
        />
        <Checkbox
          label="One per address"
          value={w.badgeOneShot}
          onChange={(v) => w.set("badgeOneShot", v)}
          hint="A wallet can only claim one token from this badge, regardless of how many codes it holds."
        />
      </div>
    </div>
  );
}
